import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AggregateTagService } from './api-services/aggregate-tag.service';

import { KYMW4601Component } from './kymw4601.component';

/**
 * タグ集約画面 モジュール設定クラス
 *
 * @export KYMW4601Module
 * @class KYMW4601Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [KYMW4601Component],
  providers: [AggregateTagService],
})
export class KYMW4601Module {}
